<div class="row pt-2" style="width: 756px;" [ngClass]="isChildPage ? 'ml-4' : 'ml-0'">
    <div class="description col-4 d-flex flex-column align-middle">
        <p class="pageTitle font-14-bold mb-1 text-wrap">{{DisplayName}}</p>
        <p class="pageSubTitle font-12 text-wrap">{{Description}}</p>
    </div>
    <div class="col-8 d-flex">
        <div class="form-check col-3 align-items-center d-flex" *ngIf="loadAccessNone">
            <input class="form-check-input" type="radio" [id]="'Radio' + parameters.data.PageID +'-1'" [(ngModel)]="maxAccess" value="0" (ngModelChange)="updateValues()" [disabled]="disabledNone"/>
            <label class="form-check-label font-14-regular d-inline-block overflow-hidden" style="text-overflow: ellipsis;" [for]="'Radio' + parameters.data.PageID +'-1'" [ngbPopover]="noneHoverMessage" triggers="mouseenter:mouseleave" 
                container="body" placement="bottom-right" langSection="Users" langKey="None"
            >
                {{getLocalizedString("None", "None")}}
            </label>
        </div>
        <div class="form-check col-3 align-items-center d-flex" *ngIf="loadAccessRead">
            <input class="form-check-input" type="radio" [id]="'Radio' + parameters.data.PageID +'-2'" [(ngModel)]="maxAccess" value="1" (ngModelChange)="updateValues()" [disabled]="disabledView"/>
            <label class="form-check-label font-14-regular d-inline-block overflow-hidden" style="text-overflow: ellipsis;" [for]="'Radio' + parameters.data.PageID +'-2'" [ngbPopover]="viewHoverMessage" triggers="mouseenter:mouseleave" 
                container="body" placement="bottom-right" langSection="Users" langKey="View"
            >
                {{getLocalizedString("View", "View")}}
            </label>
        </div>
        <div class="form-check col-3 align-items-center d-flex" *ngIf="loadAccessEdit">
            <input class="form-check-input" type="radio" [id]="'Radio' + parameters.data.PageID +'-3'" [(ngModel)]="maxAccess" value="2" (ngModelChange)="updateValues()" [disabled]="disabledEdit"/>
            <label class="form-check-label font-14-regular d-inline-block overflow-hidden" style="text-overflow: ellipsis;" [for]="'Radio' + parameters.data.PageID +'-3'" [ngbPopover]="editHoverMessage" triggers="mouseenter:mouseleave" 
                container="body" placement="bottom-right" langSection="Users" langKey="Edit"
            >
                {{getLocalizedString("Edit", "Edit")}}
            </label>
        </div>
        <div class="form-check col-3 align-items-center d-flex" *ngIf="loadAccessCreate">
            <input class="form-check-input" type="radio" [id]="'Radio' + parameters.data.PageID +'-4'" [(ngModel)]="maxAccess" value="3" (ngModelChange)="updateValues()" [disabled]="disabledCreate"/>
            <label class="form-check-label font-14-regular d-inline-block overflow-hidden" style="text-overflow: ellipsis;" [for]="'Radio' + parameters.data.PageID +'-4'" [ngbPopover]="createHoverMessage" triggers="mouseenter:mouseleave" 
                container="body" placement="bottom-right" langSection="Users" langKey="Create"
            >
                {{getLocalizedString("Create", "Create")}}
            </label>
        </div>
    </div>
</div>
